// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.easycommerce .easycommerce-product-details p {
    color: var(--color-ec-body);
    font-family: "Inter", system-ui;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    margin-bottom: 24px;
}
.easycommerce .easycommerce-product-details h1,
.easycommerce .easycommerce-product-details h2,
.easycommerce .easycommerce-product-details h3,
.easycommerce .easycommerce-product-details h4,
.easycommerce .easycommerce-product-details h5,
.easycommerce .easycommerce-product-details h6 {
    color: var(--color-ec-body);
    font-family: "Inter", system-ui;
    font-weight: 700;
    line-height: 26px;
    margin-bottom: 24px;
}
.easycommerce .easycommerce-product-details h1 {
    font-size: 32px;
}
.easycommerce .easycommerce-product-details h2 {
    font-size: 28px;
}
.easycommerce .easycommerce-product-details h3 {
    font-size: 26px;
}
.easycommerce .easycommerce-product-details h4 {
    font-size: 24px;
}
.easycommerce .easycommerce-product-details h5 {
    font-size: 22px;
}
.easycommerce .easycommerce-product-details h6 {
    font-size: 20px;
}
.easycommerce .easycommerce-review-form textarea {
    min-height: 106px;
}
.easycommerce .easycommerce-review-form input[type="text"],
.easycommerce .easycommerce-review-form input[type="email"] {
    padding: 15px;
    height: 48px;
    border: 1px solid var(--color-ec-border);
}
.easycommerce .easycommerce-review-form textarea:focus,
.easycommerce .easycommerce-review-form input:focus {
    outline: none;
    box-shadow: none;
    border: 1px solid var(--color-ec-primary);
}
`, "",{"version":3,"sources":["webpack://./blocks/single-product/product-tab/assets/editor.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;;;;;;IAMI,2BAA2B;IAC3B,+BAA+B;IAC/B,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;;IAEI,aAAa;IACb,YAAY;IACZ,wCAAwC;AAC5C;AACA;;IAEI,aAAa;IACb,gBAAgB;IAChB,yCAAyC;AAC7C","sourcesContent":[".easycommerce .easycommerce-product-details p {\n    color: var(--color-ec-body);\n    font-family: \"Inter\", system-ui;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 26px;\n    margin-bottom: 24px;\n}\n.easycommerce .easycommerce-product-details h1,\n.easycommerce .easycommerce-product-details h2,\n.easycommerce .easycommerce-product-details h3,\n.easycommerce .easycommerce-product-details h4,\n.easycommerce .easycommerce-product-details h5,\n.easycommerce .easycommerce-product-details h6 {\n    color: var(--color-ec-body);\n    font-family: \"Inter\", system-ui;\n    font-weight: 700;\n    line-height: 26px;\n    margin-bottom: 24px;\n}\n.easycommerce .easycommerce-product-details h1 {\n    font-size: 32px;\n}\n.easycommerce .easycommerce-product-details h2 {\n    font-size: 28px;\n}\n.easycommerce .easycommerce-product-details h3 {\n    font-size: 26px;\n}\n.easycommerce .easycommerce-product-details h4 {\n    font-size: 24px;\n}\n.easycommerce .easycommerce-product-details h5 {\n    font-size: 22px;\n}\n.easycommerce .easycommerce-product-details h6 {\n    font-size: 20px;\n}\n.easycommerce .easycommerce-review-form textarea {\n    min-height: 106px;\n}\n.easycommerce .easycommerce-review-form input[type=\"text\"],\n.easycommerce .easycommerce-review-form input[type=\"email\"] {\n    padding: 15px;\n    height: 48px;\n    border: 1px solid var(--color-ec-border);\n}\n.easycommerce .easycommerce-review-form textarea:focus,\n.easycommerce .easycommerce-review-form input:focus {\n    outline: none;\n    box-shadow: none;\n    border: 1px solid var(--color-ec-primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
